import { Container, Box, Modal, Button, Grid, Typography } from '@mui/material'
import { useEffect, useState } from 'react';
import {
    warningModal, handleAddEditModal, setNewBrandModal, handleAddEditUnitOfMeasures, handleAddEditVat, handleAddEditCbs, handleAddEditPdcPriceModal, handleAddEditSupplier,
    handleViewMoreModal, handleFileUploadModal, handleAddEditDC, handleAddEditdiscountScheme, handleAddEditPriceModal, handleRDSchemeModal, handleAddEditDisputedInvoiceModal, handleAddEditLevyBillingModal,
    handleAddEditRetroBillingModal, handleAddEditRetroFinalModal, handleAddEditRetroInterimModal, handleUserDisputeModal, releaseSystemDisputeModal, deleteCategoryModal
} from "../../../store/slices/modals";
import { hasTabEdit, resetProduct, setProductId, setEanCodeDeleteData } from "../../../store/slices/generalProduct";
import { resetVC } from "../../../store/slices/vcProduct";
import { resetPdc } from "../../../store/slices/pdcProduct";
import { useDispatch, useSelector } from 'react-redux';
import { resetUOM, setUOMDeleteData } from '../../../store/slices/uomProduct';
import { resetBrand, setdeleteBrandOwner } from '../../../store/slices/brandProduct';
import { resetSupplier, setSupplierDeleteData } from "../../../store/slices/supplierProduct";
import { resetDC, setDCSingleDeleteData } from "../../../store/slices/distributionChannel";
import { resetSupplierAccounts } from "../../../store/slices/supplierAccounts";
import { resetaggregationGroup } from "../../../store/slices/aggregationGroup";
import { resetrdsoe, setrdsoeDeleteData } from "../../../store/slices/rdsoe";
import { resetretrodiscountschemes, rowDeleteYes, setRetroState, memberFetchAll } from "../../../store/slices/retrodiscountschemes";
import { resetinvoiceSummary } from "../../../store/slices/invoiceSummary";
import { resetsupplierReports } from "../../../store/slices/supplierReports";
import { editProductUploadModal, fileDeleteYes, singleDeleteYes, wrongFile } from '../../../store/slices/fileUpload';
import { pdcwrongFile } from '../../../store/slices/pdcsFileUpload';
import { resetediFileLog } from "../../../store/slices/ediFileLog";
import { resetfailedImports } from "../../../store/slices/failedImports";
import { resetcbs, setcbsDeleteData } from "../../../store/slices/cbsProduct";
import { resetPdcProduct, setPdcSpcDeleteData } from "../../../store/slices/generalPdcProduct";
import { resetcommonProduct } from "../../../store/slices/commonProduct";
import { resetchannel_price, setSingleDeleteData } from "../../../store/slices/pricePdcProduct";
import { resetorganisationType, setOrganisationTypeDeleteData } from "../../../store/slices/organisationType";
import { resetProgramme } from "../../../store/slices/programme";
import { resetSMA, setSmaDeleteData } from "../../../store/slices/supplierMemberAccounts";
import { resetdiscountScheme, setDiscountSchemeDeleteData } from "../../../store/slices/discountScheme";
import { resetlevyScheme, setLevySchemeDeleteData } from "../../../store/slices/levyScheme";
import { setHandleReportModal } from '../../../store/slices/manualInvoice';
import { resetpromotionType, setpromotionTypeDeleteData } from "../../../store/slices/promotionType";
import { resetprocessManager, memberInvoiceProcessData } from "../../../store/slices/processManager";
import { failedImportDeleteYes } from '../../../store/slices/failedImports';
import { releaseSystemDisputeStatus } from '../../../store/slices/invoiceDisputes';
import { deleteCategoryStatus } from '../../../store/slices/categoriesData';
import { setReprocessDeleteData, setProcessData, resetProcessData } from '../../../store/slices/invoiceReprocess';
import { setEmailStatus, resetsendEmails } from '../../../store/slices/membersupplierReports';

function WarningModal({ onShow, size = '', pagelocation }) {

    const [open, setOpen] = useState(onShow);

    const { modalWarning, deleteBO, fileUpload, pdcfileUpload, deletePdc, showAddEditPriceModal, distributionChannel_container, 
        showAddEditPriceLeavyModal, deleteProcessManagers, showAddEdiMemberInvoiceModal, failedInvoiceImports, invoiceDispute, sma_container,
        levyScheme_container, discountScheme_container, general_product_fields, supplier_container, pdc_general_product_fields,
        organisation_type_fields, retrodiscountscheme_fields, rdsoe_fields, promotionType_container, cbs_container, category_fields, 
        uom_container, retro_fields, invoicereprocess_fields, membersupplier_reports_fields } = useSelector((state) => {
            return {
                modalWarning: state.modalActions.closeWaringAddProduct,
                deleteBO: state.brandProducts,
                fileUpload: state.productFileUpload,
                pdcfileUpload: state.pdcsUpload,
                deletePdc: state.pricePdcProducts,
                showAddEditPriceModal: state.modalActions.hideAddEditPdcModal,
                distributionChannel_container: state.dcProducts,
                showAddEditPriceLeavyModal: state.modalActions.hideAddEditPriceModal,
                deleteProcessManagers: state.processManagers,
                failedInvoiceImports: state.failedImports,
                invoiceDispute: state.invoiceDisputes,
                sma_container: state.smas,
                levyScheme_container: state.levySchemes,
                discountScheme_container: state.discountSchemes,
                general_product_fields: state.generalProduct,
                supplier_container: state.supplierProducts,
                pdc_general_product_fields: state.generalPdcProducts,
                organisation_type_fields: state.organisationTypes,
                retrodiscountscheme_fields: state.retrodiscountscheme,
                rdsoe_fields: state.rdsoes,
                promotionType_container: state.promotionTypes,
                cbs_container: state.cbsProducts,
                category_fields: state.categoriesData,
                uom_container: state.uomProducts,
                retro_fields: state.retrodiscountscheme,
                invoicereprocess_fields: state.invoiceReprocess,
                membersupplier_reports_fields : state.membersupplierReports
            }
        });

    const dispatch = useDispatch();

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleShowHide = () => {
        dispatch(handleAddEditModal({
            showAddEdit: !modalWarning,
        }))
        dispatch(handleAddEditUnitOfMeasures({
            showAddEdit: !modalWarning,
        }))
        dispatch(handleAddEditVat({
            showAddEdit: !modalWarning,
        }))
        dispatch(handleAddEditCbs({
            showAddEdit: !modalWarning,
        }))
        dispatch(warningModal({
            yesHide: false
        }))
        dispatch(handleAddEditPdcPriceModal({
            showAddEditPrice: !showAddEditPriceModal
        }))
        dispatch(handleAddEditSupplier({
            showAddEdit: !modalWarning,
        }))
        dispatch(handleViewMoreModal({
            showViewMore: !modalWarning,
        }))
        dispatch(handleFileUploadModal({
            showFileUpload: !modalWarning
        }))
        dispatch(handleAddEditDC({
            showAddEdit: !modalWarning
        }))
        dispatch(handleAddEditdiscountScheme({
            showAddEdit: !modalWarning
        }))
        dispatch(setProductId(null))
        dispatch(handleRDSchemeModal({
            addEditRDSchemeModal: false
        }))
        dispatch(handleAddEditDisputedInvoiceModal({
            showAddEditDisputedInvoiceModal: !modalWarning
        }))
        dispatch(handleAddEditLevyBillingModal({
            showAddEditLevyBillingModal: !modalWarning
        }))
        dispatch(handleAddEditRetroBillingModal({
            showAddEdiRetroBillingModal: !modalWarning
        }))
        dispatch(handleAddEditRetroFinalModal({
            showAddEdiRetroFinalModal: !modalWarning
        }))
        dispatch(handleAddEditRetroInterimModal({
            showAddEdiRetroInterimModal: !modalWarning
        }))
        dispatch(handleUserDisputeModal({
            showAddEditUserDispute: !modalWarning,
        }))

        dispatch(hasTabEdit({ editTab: true }))
        dispatch(setHandleReportModal(false))
        //dispatch(resetProduct())
        //dispatch(resetUOM())
        dispatch(resetVC())
        dispatch(resetPdc())
        //dispatch(resetSupplier())
        //dispatch(resetDC())
        dispatch(resetSupplierAccounts())
        dispatch(resetaggregationGroup())
        //dispatch(resetrdsoe())
        //dispatch(resetretrodiscountschemes()) 
        dispatch(resetinvoiceSummary())
        dispatch(resetsupplierReports())
        dispatch(resetediFileLog())
        dispatch(resetfailedImports())
        //dispatch(resetcbs())
        //dispatch(resetPdcProduct())
        dispatch(resetcommonProduct())
        //dispatch(resetchannel_price())
        //dispatch(resetorganisationType())
        dispatch(editProductUploadModal(false))
        dispatch(resetProgramme())
        //dispatch(resetdiscountScheme())
        //dispatch(resetlevyScheme())
        //dispatch(resetpromotionType())
        //dispatch(resetprocessManager())
        dispatch(handleAddEditPriceModal({
            showAddEditPriceModal: false
        }))

        if (deleteBO.deleteProcess) {
            dispatch(setdeleteBrandOwner({
                key: 'okDelete',
                value: true
            }))
        } else {
            dispatch(setNewBrandModal({
                showAddEdit: !modalWarning,
            }))
            dispatch(resetBrand())
        }
        if (fileUpload.startSingleDelete) {
            dispatch(singleDeleteYes({
                key: 'confirmSingleDelete',
                value: true
            }))
        }
        if (fileUpload.startFileDelete) {
            dispatch(fileDeleteYes({
                key: 'confirmFileDelete',
                value: true
            }))
        }
        if (deletePdc.pdcstartSingleDelete) {
            dispatch(handleAddEditPdcPriceModal({
                showAddEditPrice: true
            }))
            dispatch(setSingleDeleteData({
                key: 'pdcconfirmSingleDelete',
                value: true
            }))
        }
        if (deletePdc.pdcChargestartSingleDelete) {
            dispatch(handleAddEditPdcPriceModal({
                showAddEditPrice: true
            }))
            dispatch(setSingleDeleteData({
                key: 'pdcChargeconfirmSingleDelete',
                value: true
            }))
        }
        if (deletePdc.pdcPromoPricestartSingleDelete) {
            dispatch(handleAddEditPdcPriceModal({
                showAddEditPrice: true
            }))
            dispatch(setSingleDeleteData({
                key: 'pdcPromoPriceconfirmSingleDelete',
                value: true
            }))
        }
        if (distributionChannel_container.dcStartSingleDelete) {
            dispatch(setDCSingleDeleteData({
                key: 'dcConfirmSingleDelete',
                value: true
            }))
        } else {
            dispatch(resetDC())
        }
        if ((!deletePdc.pdcstartSingleDelete) && (!deletePdc.pdcChargestartSingleDelete) && (!deletePdc.pdcPromoPricestartSingleDelete)) {
            dispatch(resetchannel_price())
        }
        if (deleteProcessManagers.memberInvoiceStartProcess) {
            dispatch(memberInvoiceProcessData({
                key: 'memberInvoiceConfirmProcess',
                value: true
            }))
        } else {
            dispatch(resetprocessManager())
        }
        if (failedInvoiceImports.startDelete) {
            dispatch(failedImportDeleteYes({
                key: 'confirmDelete',
                value: true
            }))
        }
        if (invoiceDispute.startReleaseSystemDispute) {
            dispatch(handleAddEditModal({
                showAddEdit: false
            }))

            dispatch(handleUserDisputeModal({
                showAddEditUserDispute: false
            }))

            dispatch(releaseSystemDisputeStatus({
                key: 'confirmReleaseSystemDispute',
                value: true
            }))
            dispatch(releaseSystemDisputeModal({
                key: 'releasesystemdispute',
                value: false
            }))
        }
        if (category_fields.startDeleteCategory) {
            dispatch(handleAddEditModal({
                showAddEdit: false
            }))
            dispatch(deleteCategoryModal({
                key: 'deleteCategory',
                value: false
            }))

            // dispatch(handleUserDisputeModal({
            //     showAddEditUserDispute: false
            // }))

            dispatch(deleteCategoryStatus({
                key: 'confirmDeleteCategory',
                value: true
            }))

        }
        if (sma_container.sma_StartSingleDelete) {
            dispatch(setSmaDeleteData({
                key: 'sma_ConfirmSingleDelete',
                value: true
            }))
        } else {
            dispatch(resetSMA())
        }
        if (levyScheme_container.levyschemeStartSingleDelete) {
            dispatch(setLevySchemeDeleteData({
                key: 'levyschemeConfirmSingleDelete',
                value: true
            }))
        }
        if (levyScheme_container.levyschemeDcStartDelete) {
            dispatch(handleAddEditModal({
                showAddEdit: true
            }))
            dispatch(setLevySchemeDeleteData({
                key: 'levyschemeDcConfirmDelete',
                value: true
            }))
        }
        if (levyScheme_container.levyschemeSupplierStartDelete) {
            dispatch(handleAddEditModal({
                showAddEdit: true
            }))
            dispatch(setLevySchemeDeleteData({
                key: 'levyschemeSupplierConfirmDelete',
                value: true
            }))
        }
        if (levyScheme_container.levyschemeProductStartDelete) {
            dispatch(handleAddEditModal({
                showAddEdit: true
            }))
            dispatch(setLevySchemeDeleteData({
                key: 'levyschemeProductConfirmDelete',
                value: true
            }))
        }
        // eslint-disable-next-line max-len
        if ((!levyScheme_container.levyschemeStartSingleDelete) && (!levyScheme_container.levyschemeDcStartDelete) && (!levyScheme_container.levyschemeSupplierStartDelete) && (!levyScheme_container.levyschemeProductStartDelete)) {
            dispatch(resetlevyScheme())
        }
        if (discountScheme_container.discountSchemeStartSingleDelete) {
            dispatch(setDiscountSchemeDeleteData({
                key: 'discountSchemeConfirmSingleDelete',
                value: true
            }))
        }
        if (discountScheme_container.discountSchemeDcStartDelete) {
            dispatch(handleAddEditdiscountScheme({
                showAddEdit: true
            }))
            dispatch(setDiscountSchemeDeleteData({
                key: 'discountSchemeDcConfirmDelete',
                value: true
            }))
        }
        if (discountScheme_container.discountSchemeProductStartDelete) {
            dispatch(handleAddEditdiscountScheme({
                showAddEdit: true
            }))
            dispatch(setDiscountSchemeDeleteData({
                key: 'discountSchemeProductConfirmDelete',
                value: true
            }))
        }
        if (discountScheme_container.discountSchemeSupplierStartDelete) {
            dispatch(handleAddEditdiscountScheme({
                showAddEdit: true
            }))
            dispatch(setDiscountSchemeDeleteData({
                key: 'discountSchemeSupplierConfirmDelete',
                value: true
            }))
        }
        if (discountScheme_container.discountSchemeBrandStartDelete) {
            dispatch(handleAddEditdiscountScheme({
                showAddEdit: true
            }))
            dispatch(setDiscountSchemeDeleteData({
                key: 'discountSchemeBrandConfirmDelete',
                value: true
            }))
        }
        if (discountScheme_container.discountSchemeMemberStartDelete) {
            dispatch(handleAddEditdiscountScheme({
                showAddEdit: true
            }))
            dispatch(setDiscountSchemeDeleteData({
                key: 'discountSchemeMemberConfirmDelete',
                value: true
            }))
        }
        if (discountScheme_container.discountSchemeProgrammeStartDelete) {
            dispatch(handleAddEditdiscountScheme({
                showAddEdit: true
            }))
            dispatch(setDiscountSchemeDeleteData({
                key: 'discountSchemeProgrammeConfirmDelete',
                value: true
            }))
        }
        // eslint-disable-next-line max-len
        if ((!discountScheme_container.discountSchemeDcStartDelete) && (!discountScheme_container.discountSchemeStartSingleDelete) && (!discountScheme_container.discountSchemeProductStartDelete) && (!discountScheme_container.discountSchemeSupplierStartDelete) && (!discountScheme_container.discountSchemeBrandStartDelete) && (!discountScheme_container.discountSchemeMemberStartDelete) && (!discountScheme_container.discountSchemeProgrammeStartDelete)) {
            dispatch(resetdiscountScheme())
        }
        if (general_product_fields.eancodeOkDelete) {
            dispatch(handleAddEditModal({
                showAddEdit: true
            }))
            dispatch(hasTabEdit({ editTab: false }))
            dispatch(setEanCodeDeleteData({
                key: 'eancodeConfirmDelete',
                value: true
            }))
        } else {
            dispatch(resetProduct())
        }
        if (supplier_container.supplierVatCodeokDelete) {
            dispatch(handleAddEditSupplier({
                showAddEdit: true
            }))
            dispatch(setSupplierDeleteData({
                key: 'supplierVatCodeConfirmDelete',
                value: true
            }))
        }
        if (supplier_container.supplier_StartDelete) {
            dispatch(setSupplierDeleteData({
                key: 'supplier_ConfirmDelete',
                value: true
            }))
        }
        if ((!supplier_container.supplierVatCodeokDelete) && (!supplier_container.supplier_StartDelete)) {
            dispatch(resetSupplier())
        }
        if (pdc_general_product_fields.spcStartSingleDelete) {
            dispatch(handleAddEditModal({
                showAddEdit: true
            }))
            dispatch(handleAddEditPdcPriceModal({
                showAddEditPrice: false
            }))
            dispatch(setPdcSpcDeleteData({
                key: 'spcConfirmSingleDelete',
                value: true
            }))
        } else {
            dispatch(resetPdcProduct())
        }
        if (organisation_type_fields.organisationTypeStartDelete) {
            dispatch(setOrganisationTypeDeleteData({
                key: 'organisationTypeConfirmDelete',
                value: true
            }))
        } else {
            dispatch(resetorganisationType())
        }
        if (retrodiscountscheme_fields.retroDiscountSchemeStartSingleDelete) {
            dispatch(setRetroState({
                key: 'retroDiscountSchemeConfirmSingleDelete',
                value: true
            }))
        } else if (retro_fields.starteDelete) {
            dispatch(rowDeleteYes({
                key: 'confirmDelete',
                value: true
            }))
            // Adding this for forcing the background modal window to stay open after clicking Yes in the current modal popup
            dispatch(handleRDSchemeModal({
                addEditRDSchemeModal: true
            }))
            // Adding this to stop other tabs getting disabled when Yes option is selected.
            dispatch(hasTabEdit({ editTab: false }))
        } else if (retro_fields.startFetchAll) {
            dispatch(memberFetchAll({
                key: 'confirmFetchAll',
                value: true
            }))
            // Adding this for forcing the background modal window to stay open after clicking Yes in the current modal popup
            dispatch(handleRDSchemeModal({
                addEditRDSchemeModal: true
            }))
            // Adding this to stop other tabs getting disabled when Yes option is selected.
            dispatch(hasTabEdit({ editTab: false }))
        }
        else {
            dispatch(resetretrodiscountschemes())
        }
        if (rdsoe_fields.rdsoeokDelete) {
            dispatch(setrdsoeDeleteData({
                key: 'rdsoedeleteProcess',
                value: true
            }))
        } else {
            dispatch(resetrdsoe())
        }
        if (promotionType_container.promotion_typeStartSingleDelete) {
            dispatch(setpromotionTypeDeleteData({
                key: 'promotion_typeConfirmSingleDelete',
                value: true
            }))
        } else {
            dispatch(resetpromotionType())
        }
        if (cbs_container.cbsStartSingleDelete) {
            dispatch(setcbsDeleteData({
                key: 'cbsConfirmSingleDelete',
                value: true
            }))
        } else {
            dispatch(resetcbs())
        }
        if (uom_container.uomStartDelete) {
            dispatch(setUOMDeleteData({
                key: 'uomConfirmDelete',
                value: true
            }))
        }
        if (uom_container.uomRateStartDelete) {
            dispatch(handleAddEditUnitOfMeasures({
                showAddEdit: true
            }))
            dispatch(setUOMDeleteData({
                key: 'uomRateConfirmDelete',
                value: true
            }))
        }
        if ((!uom_container.uomStartDelete) && (!uom_container.uomRateStartDelete)) {
            dispatch(resetUOM())
        }
        if (invoicereprocess_fields.reprocessStartDelete) {
            dispatch(setReprocessDeleteData({
                key: 'reprocessConfirmDelete',
                value: true
            }))
        } else {
            dispatch(resetorganisationType())
        }
        if (invoicereprocess_fields.processStart) {
            dispatch(setProcessData({
                key: 'processConfirm',
                value: true
            }))
        } else {
            dispatch(resetProcessData())
        }
        if (membersupplier_reports_fields.memberStartBulkEmail) {
            dispatch(setEmailStatus({
                key: 'memberConfirmBulkEmail',
                value: true
            }));
        }
        if (membersupplier_reports_fields.supplierStartBulkEmail) {
            dispatch(setEmailStatus({
                key: 'supplierConfirmBulkEmail',
                value: true
            }));
        }
    }

    const handleSelf = () => {
        dispatch(warningModal({
            yesHide: false
        }))
        dispatch(setdeleteBrandOwner({
            key: 'okDelete',
            value: false
        }))
        dispatch(setdeleteBrandOwner({
            key: 'deleteProcess',
            value: false
        }))
        dispatch(singleDeleteYes({
            key: 'startSingleDelete',
            value: false
        }))
        dispatch(fileDeleteYes({
            key: 'startFileDelete',
            value: false
        }))
        dispatch(setSingleDeleteData({
            key: 'pdcstartSingleDelete',
            value: false
        }))
        dispatch(setSingleDeleteData({
            key: 'pdcChargestartSingleDelete',
            value: false
        }))
        dispatch(setSingleDeleteData({
            key: 'pdcPromoPricestartSingleDelete',
            value: false
        }))
        dispatch(setDCSingleDeleteData({
            key: 'dcStartSingleDelete',
            value: false
        }))
        dispatch(memberInvoiceProcessData({
            key: 'memberInvoiceStartProcess',
            value: false
        }))
        dispatch(failedImportDeleteYes({
            key: 'startDelete',
            value: false
        }))
        dispatch(deleteCategoryStatus({
            key: 'startDeleteCategory',
            value: false
        }))
        dispatch(deleteCategoryModal({
            key: 'deleteCategory',
            value: false
        }))
        dispatch(releaseSystemDisputeStatus({
            key: 'startReleaseSystemDispute',
            value: false
        }))
        dispatch(releaseSystemDisputeModal({
            key: 'releasesystemdispute',
            value: false
        }))
        dispatch(setSmaDeleteData({
            key: 'sma_StartSingleDelete',
            value: false
        }))
        dispatch(setLevySchemeDeleteData({
            key: 'levyschemeDcStartDelete',
            value: false
        }))
        dispatch(setLevySchemeDeleteData({
            key: 'levyschemeSupplierStartDelete',
            value: false
        }))
        dispatch(setLevySchemeDeleteData({
            key: 'levyschemeProductStartDelete',
            value: false
        }))
        dispatch(setDiscountSchemeDeleteData({
            key: 'discountSchemeDcStartDelete',
            value: false
        }))
        dispatch(setDiscountSchemeDeleteData({
            key: 'discountSchemeProductStartDelete',
            value: false
        }))
        dispatch(setDiscountSchemeDeleteData({
            key: 'discountSchemeSupplierStartDelete',
            value: false
        }))
        dispatch(setDiscountSchemeDeleteData({
            key: 'discountSchemeBrandStartDelete',
            value: false
        }))
        dispatch(setDiscountSchemeDeleteData({
            key: 'discountSchemeMemberStartDelete',
            value: false
        }))
        dispatch(setDiscountSchemeDeleteData({
            key: 'discountSchemeProgrammeStartDelete',
            value: false
        }))
        dispatch(setEanCodeDeleteData({
            key: 'eancodeOkDelete',
            value: false
        }))
        dispatch(setSupplierDeleteData({
            key: 'supplierVatCodeokDelete',
            value: false
        }))
        dispatch(setPdcSpcDeleteData({
            key: 'spcStartSingleDelete',
            value: false
        }))
        dispatch(setSupplierDeleteData({
            key: 'supplier_StartDelete',
            value: false
        }))
        dispatch(setOrganisationTypeDeleteData({
            key: 'organisationTypeStartDelete',
            value: false
        }))
        dispatch(setDiscountSchemeDeleteData({
            key: 'discountSchemeStartSingleDelete',
            value: false
        }))
        dispatch(setLevySchemeDeleteData({
            key: 'levyschemeStartSingleDelete',
            value: false
        }))
        dispatch(setRetroState({
            key: 'retroDiscountSchemeStartSingleDelete',
            value: false
        }))
        dispatch(setrdsoeDeleteData({
            key: 'rdsoeokDelete',
            value: false
        }))
        dispatch(setpromotionTypeDeleteData({
            key: 'promotion_typeStartSingleDelete',
            value: false
        }))
        dispatch(setcbsDeleteData({
            key: 'cbsStartSingleDelete',
            value: false
        }))
        dispatch(setUOMDeleteData({
            key: 'uomStartDelete',
            value: false
        }))
        dispatch(setUOMDeleteData({
            key: 'uomRateStartDelete',
            value: false
        }))
        dispatch(rowDeleteYes({
            key: 'starteDelete',
            value: false
        }))
        dispatch(memberFetchAll({
            key: 'startFetchAll',
            value: false
        }))
        dispatch(wrongFile({
            key: 'wrongFileUpload',
            value: false
        }));
        dispatch(pdcwrongFile({
            key: 'wrongFileUpload',
            value: false
        }));
        dispatch(setEmailStatus({
            key: 'memberStartBulkEmail',
            value: false
        }));
        dispatch(setEmailStatus({
            key: 'supplierStartBulkEmail',
            value: false
        }));
    }

    return (
        <>
            <Modal
                open={open}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
                keepMounted
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose();
                    }
                }}
            >
                <Box component="div" className="overlay" id="addEditModal">
                    <div className={`overlay-box ${size ? size : ''}`}>
                        <div className="content">
                            <div className="overlayBody">
                                {/* <div className="overlay-header text-center"> Are you sure want to cancel ?
                                    <CancelIcon className="closeBtn" onClick={handleClose} />
                                </div> */}
                                <div className="overlay-content">
                                    <Box component="div" sx={{ textAlign: 'center', padding: 1.5 }}>
                                        <p className="fontMedium">{deleteBO.deleteProcess ? 'Are you sure you want to delete?' : deletePdc.pdcstartSingleDelete ? 'Are you sure you want to delete?' : retrodiscountscheme_fields.retroDiscountSchemeStartSingleDelete ? 'Are you sure you want to delete?' : (uom_container.uomStartDelete || uom_container.uomRateStartDelete) ? 'Are you sure you want to delete?' : promotionType_container.promotion_typeStartSingleDelete ? 'Are you sure you want to delete?' : deleteProcessManagers.memberInvoiceStartProcess ? 'This will run the "Member Invoice printing". Do you want to proceed?' : deletePdc.pdcChargestartSingleDelete ? 'Are you sure you want to delete?' : organisation_type_fields.organisationTypeStartDelete ? 'Are you sure you want to delete?' : cbs_container.cbsStartSingleDelete ? 'Are you sure you want to delete?' : rdsoe_fields.rdsoeokDelete ? 'Are you sure you want to delete?' : (supplier_container.supplierVatCodeokDelete || supplier_container.supplier_StartDelete) ? 'Are you sure you want to delete?' : deletePdc.pdcPromoPricestartSingleDelete ? 'Are you sure you want to delete?' : sma_container.sma_StartSingleDelete ? 'Are you sure you want to delete?' : distributionChannel_container.dcStartSingleDelete ? 'Are you sure you want to delete?' : (discountScheme_container.discountSchemeStartSingleDelete || discountScheme_container.discountSchemeDcStartDelete || discountScheme_container.discountSchemeProductStartDelete || discountScheme_container.discountSchemeSupplierStartDelete || discountScheme_container.discountSchemeBrandStartDelete || discountScheme_container.discountSchemeMemberStartDelete || discountScheme_container.discountSchemeProgrammeStartDelete) ? 'Are you sure you want to delete?' : (levyScheme_container.levyschemeStartSingleDelete || levyScheme_container.levyschemeDcStartDelete || levyScheme_container.levyschemeProductStartDelete || levyScheme_container.levyschemeSupplierStartDelete || retro_fields.starteDelete) ? 'Are you sure you want to delete?' :
                                            fileUpload.startSingleDelete ? "Are you sure want to delete?" : general_product_fields.eancodeOkDelete ? 'Are you sure you want to delete?' : pdc_general_product_fields.spcStartSingleDelete ? 'Are you sure you want to delete?' : fileUpload.startFileDelete ? 'Are you sure you want to delete all records present in table?' : failedInvoiceImports.startDelete ? "Are you sure want to delete?" : invoiceDispute.startReleaseSystemDispute ? 'Are you sure you want to Release Sytem Dispute?' : category_fields.startDeleteCategory ? 'Are you sure you want to delete Category?' : invoicereprocess_fields.reprocessStartDelete ? <Box><Typography sx={{ fontSize: '14px', fontWeight: '500', lineHeight: 'unset' }}>Are you sure you want to remove this entry from Invoice Reprocess?</Typography><Typography sx={{ fontSize: '12px', fontWeight: '700' }}>Note: Invoice will still be available in Invoice Summary page</Typography></Box> : invoicereprocess_fields.processStart ? `Are you sure you want to ${invoicereprocess_fields.processName}?` : fileUpload.wrongFileUpload || pdcfileUpload.wrongFileUpload  ? 'The file you have uploaded is incorrect, please upload correct file' : membersupplier_reports_fields.memberStartBulkEmail ? 'Are you sure you want to send bulk email to selected members group?' : membersupplier_reports_fields.supplierStartBulkEmail ? 'Are you sure you want to send bulk email to selected supplier group?' : retro_fields.startFetchAll ? 'Are you sure you want to fetch all Members details, It will override your existing selections?' : 'Are you sure want to cancel?'}</p>
                                        {
                                            fileUpload.wrongFileUpload || pdcfileUpload.wrongFileUpload ? (
                                                <Grid sx={{ paddingTop: 2 }} container direction="row" alignItems="center" justifyContent="center">
                                                    <Button variant="contained" type="submit" sx={{ marginRight: '15px' }} onClick={handleSelf}>Okay</Button>
                                                    {/* <Button variant="outlined" onClick={handleSelf}>No</Button> */}
                                                </Grid>
                                            ) : (
                                                <Grid sx={{ paddingTop: 2 }} container direction="row" alignItems="center" justifyContent="center">
                                                    <Button variant="contained" type="submit" sx={{ marginRight: '15px' }} onClick={handleShowHide}>Yes</Button>
                                                    <Button variant="outlined" onClick={handleSelf}>No</Button>
                                                </Grid>
                                            )
                                        }

                                    </Box>
                                </div>
                            </div>
                        </div>
                    </div>
                </Box>
            </Modal>
        </>
    );
}

export default WarningModal;